import script from "./PrincipalPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrincipalPageView.vue?vue&type=script&setup=true&lang=ts"

import "./PrincipalPageView.vue?vue&type=style&index=0&id=edb6b056&lang=css"

const __exports__ = script;

export default __exports__